module.exports = __webpack_public_path__ + "img/step-2.bf9b2abd.jpg";